import React from 'react';
import { PageContentStyled } from 'components/molecules/PageContent/styled';
import AdminHeader from 'components/organisms/Header';
import { StyledContentWrapper } from 'components/molecules/ContentWrapper/styled';
import FormStepper from 'components/molecules/FormSteper';
import Modal from 'components/molecules/Modal';
import {
  dishesSteps,
  optionSteps,
  categoriesStep,
} from 'common/constants/menu';
import { useLocation } from 'react-router-dom';
import { useCommon } from 'redux/common/use-common';
import { useCompany } from 'redux/company/use-company';
import { useDishes } from 'redux/dishes/use-dishes';
import { useDishCategory } from 'redux/dishes_categories/use-dish-category';
import { useSpecialMenu } from 'redux/special_menu/use-special-menu';
import { useDishOptions } from 'redux/dishes_options/use-dish-options';
import { errorsVariants } from 'services/ErrorHelper';
import { useCurrentRestaurant } from 'redux/restaurant/use-restaurant';
import { useSuperAdmin } from 'hooks/super-admin';

const getStepsParams = (pathname, allData = {}) => {
  const data = {
    steps: dishesSteps,
    completed: [],
    errors: null,
    variant: errorsVariants.menuDishes,
    cb: () => {},
  };
  if (pathname.includes('categories')) {
    data.completed = allData.categoryCompleted;
    data.cb = allData.handleChangeDishCategoryStep;
    data.steps = categoriesStep;
    data.errors = allData.dishCategoriesErrors;
    data.variant = errorsVariants.dishCategories;
  }
  if (pathname.includes('dishes')) {
    data.completed = allData.dishesCompleted;
    data.errors = allData.dishesErrors;
    data.variant = errorsVariants.menuDishes;
    data.steps = dishesSteps;
    data.cb = allData.handleChangeDishStep;
  }
  if (pathname.includes('special-menu')) {
    data.completed = allData.specialMenuCompleted;
    data.errors = allData.specialMenuErrors;
    data.variant = errorsVariants.specialMenu;
    data.steps = dishesSteps;
    data.cb = allData.specialMenuChangeStep;
  }
  if (pathname.includes('options')) {
    data.completed = allData.optionsCompletedSteps;
    data.errors = allData.dishOptionErrors;
    data.variant = errorsVariants.dishOptions;
    data.step = allData.dishOptionsStep;
    data.cb = allData.handleDishOptionChangeStep;
    data.steps = optionSteps;
  }
  return data;
};

const LayoutShell = ({ children }) => {
  const {
    modalData,
    handleResetModalData,
    handleSubmitModalAction,
  } = useCommon();
  const { pathname } = useLocation();
  const { deleteInProcess } = useCompany();
  useSuperAdmin();

  const { inProcess: restaurantUpdateInProcess } = useCurrentRestaurant();

  const {
    step: dishesStep,
    completedSteps: dishesCompleted,
    deleteInProcess: dishesDeleteInProcess,
    createOrUpdateErrors: dishesErrors,
    handleChangeDishStep,
  } = useDishes();

  const {
    completedSteps: categoryCompleted,
    step: dishCategoryStep,
    handleChangeDishStep: handleChangeDishCategoryStep,
    createOrUpdateErrors: dishCategoriesErrors,
    deleteInProcess: dishCategoryDeleteInProcess,
  } = useDishCategory();
  const {
    step: specialMenuStep,
    completedSteps: specialMenuCompleted,
    handleChangeDishStep: specialMenuChangeStep,
    createOrUpdateErrors: specialMenuErrors,
    deleteInProcess: specialMenuDeleteInProcess,
  } = useSpecialMenu();

  const {
    step: dishOptionsStep,
    completedSteps: optionsCompletedSteps,
    errors: dishOptionErrors,
    handleChangeDishStep: handleDishOptionChangeStep,
    deleteInProcess: dishOptionsDeleteInProcess,
  } = useDishOptions();

  const { steps, completed, errors, variant, cb, ...rest } = getStepsParams(
    pathname,
    {
      dishesCompleted,
      categoryCompleted,
      specialMenuCompleted,
      optionsCompletedSteps,
      dishesErrors,
      handleChangeDishStep,
      specialMenuChangeStep,
      specialMenuErrors: specialMenuErrors?.special_menu,
      dishOptionErrors,
      dishCategoriesErrors,
      handleDishOptionChangeStep,
      handleChangeDishCategoryStep,
      dishesStep,
      dishCategoryStep,
      specialMenuStep,
      dishOptionsStep,
    },
  );

  return (
    <PageContentStyled>
      <AdminHeader />
      <StyledContentWrapper>
        <FormStepper
          onClick={cb}
          errors={errors}
          variant={variant}
          steps={steps}
          completedSteps={completed}
          {...rest}
        />
        {children}
      </StyledContentWrapper>
      <Modal
        inProcess={
          deleteInProcess ||
          dishesDeleteInProcess ||
          specialMenuDeleteInProcess ||
          dishOptionsDeleteInProcess ||
          dishCategoryDeleteInProcess ||
          restaurantUpdateInProcess
        }
        cancelButtonText={modalData.cancelText}
        headerCenter={true}
        open={modalData.open}
        onClose={handleResetModalData}
        title={modalData.title}
        body={modalData.body}
        onCancel={handleResetModalData}
        onSubmit={handleSubmitModalAction}
        variant={modalData.variant}
        desktopMinH='auto'
      />
    </PageContentStyled>
  );
};

export default LayoutShell;
